import { useSelector } from 'hooks/utils';
import { selectProjectOrganizations } from 'store/data/collaborators';

export function useProjectOrganizations() {
	return useSelector(state => selectProjectOrganizations(state.data.collaborators));
}
